import React from "react";
import "./Skills.css";
import { FaLaptopCode, FaUsersCog, FaTools } from "react-icons/fa";

const Skills = () => {
  return (
    <section className="skills-container">
      <h2 className="skills-heading">Skills</h2>
      <div className="skills-grid">
        <div className="skill-category">
          <FaLaptopCode className="skill-icon" />
          <h3>Technical Skills</h3>
          <ul>
            <li>Data Entry & Management</li>
            <li>CRM Tools (HubSpot, Zoho, Salesforce)</li>
            <li>Microsoft Office & Google Suite</li>
            <li>Basic Web Design (HTML, CSS, JavaScript)</li>
            <li>Social Media Management</li>
          </ul>
        </div>
        <div className="skill-category">
          <FaUsersCog className="skill-icon" />
          <h3>Administrative Skills</h3>
          <ul>
            <li>Calendar & Email Management</li>
            <li>Project Coordination</li>
            <li>Customer Support</li>
            <li>Travel & Expense Tracking</li>
            <li>Digital Marketing</li>
          </ul>
        </div>
        <div className="skill-category">
          <FaTools className="skill-icon" />
          <h3>Soft Skills</h3>
          <ul>
            <li>Excellent Communication</li>
            <li>Problem-Solving</li>
            <li>Time Management</li>
            <li>Attention to Detail</li>
            <li>Adaptability & Reliability</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Skills;
